"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheData = void 0;
var CacheData = /** @class */ (function () {
    function CacheData(_enabled, _ttl) {
        this._enabled = _enabled;
        this._ttl = _ttl;
        this._data = undefined;
        this._ttlHandler = null;
    }
    Object.defineProperty(CacheData.prototype, "Enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
        },
        enumerable: false,
        configurable: true
    });
    CacheData.prototype.get = function () {
        if (!this._enabled) {
            return undefined;
        }
        return this._data;
    };
    CacheData.prototype.set = function (data) {
        var _this = this;
        this._data = data;
        if (this._ttlHandler) {
            clearTimeout(this._ttlHandler);
        }
        this._ttlHandler = setTimeout(function () {
            _this._data = undefined;
        }, this._ttl);
    };
    CacheData.prototype.clear = function () {
        this._data = undefined;
    };
    return CacheData;
}());
exports.CacheData = CacheData;
//# sourceMappingURL=cache.js.map